import styled from "styled-components";
import PWAUtil from "../lib/pwa";
import { connect } from "react-redux";
import { IonIcon, isPlatform } from "@ionic/react";
import { useState } from "react";
import xookATHS from '../assets/xookATHS.webp';
import { closeOutline } from "ionicons/icons";

const InstallPwaCard = styled.div`
	display: flex;
	flex-direction: column;
	background: #4b4b4b;
	padding: 1rem;
	border-radius: 6px;
	width: 100%;
	margin: 1rem 0 0 0;
	gap: 0.5rem;
    position: relative;
`;

const InstallHeader = styled.div`
	display: flex;
	align-items: center;
	align-self: flex-end;
	flex-direction: row;
	color: #fff;
	font-size: 16px;
	font-weight: 500;
	width: 100%;
`;

const InstallMessage = styled.div`
	display: flex;
	align-items: center;
	align-self: flex-end;
	flex-direction: row;
	color: #9b9b9b;
	font-size: 13px;
    line-height: 18px;
	font-weight: 400;
	width: 100%;
	text-align: left;
`;

export const InstallCTA = styled.div<any>`
	padding: 0.5rem;
	width: 90px;
	height: 30px;
	color: #fff;
	border-radius: 4px;
	display: flex;
	-webkit-box-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	align-items: center;
	font-weight: 500;
	font-size: 14px;
	margin: 0px 0px 0px auto;
	border: 1.5px solid #fff;
`;

const Row = styled.div<any>`
	display: flex;
    align-items: center;
	width: 100%;
	gap: 1rem;
`;

const Column = styled.div<any>`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: max-content;
`;

const IconContainer = styled.div`
    width:50px;
    height:50px;
`;

const Icon = styled.img`
    height: 40px;
    width: 40px;
`;

const CloseIconContainer = styled.div`
    display:flex;
    align-items:flex-start;
    justify-content: right;
    position: absolute;
    top: 0.3rem;
    right: 0.5rem;
    height: 30px;
    width: 30px;
`;

const CloseIcon = styled(IonIcon)`
    color: #FFF;
    font-size: 15px;
`;

const ATHS = (props: any) => {
	const [hideComponent, setHideComponent] = useState(false);
	const { canInstallPWA } = props;

	return !hideComponent && isPlatform("android") && canInstallPWA ? (
		<InstallPwaCard>
            <CloseIconContainer onClick={() => setHideComponent(true)} >
                <CloseIcon src={closeOutline} />
            </CloseIconContainer>
			<Row>
				<IconContainer>
                    <Icon src={xookATHS} />
                </IconContainer>
				<Column>
					<InstallHeader>Liking the Experience?</InstallHeader>
					<InstallMessage>Add a shortlink to your home screen for quicker access.</InstallMessage>
				</Column>
			</Row>
			<InstallCTA onClick={PWAUtil.installPWA}>ADD</InstallCTA>
		</InstallPwaCard>
	) : (
		<span></span>
	);
};
// Map state from Redux to component props
const mapStateToProps = (state: { Xook: { canInstallPWA: any } }) => ({
	canInstallPWA: state.Xook.canInstallPWA
});

export default connect(mapStateToProps)(ATHS);
